var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./perfil-featured.js"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-524b75ac\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./perfil-featured.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/perfil/components/perfil-featured/perfil-featured.vue
// module id = 275
// module chunks = 0